/**
 * Modal Header Actions component
 */
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'modal-header-actions',
  templateUrl: './modal-header-actions.component.html',
  styleUrls: ['./modal-header-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ModalHeaderActionsComponent {}
